var map = {
	"./bbc54yyk/login_bg.jpg": 1868,
	"./chaoxinxing/login_bg.jpg": 1872,
	"./yyk/login_bg.jpg": 399
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 428;


//////////////////
// WEBPACK FOOTER
// ./static/img ^\.\/.*\/login_bg\.jpg$
// module id = 428
// module chunks = 0